import {
	BrowserRouter as Router,
	Switch,
	Route,
	Link,
	useHistory
} from "react-router-dom";
import React from 'react';
import Home from '../Home/Home';
import './Header.css'
const Header = () => {

	const currentRoute = useHistory().location.pathname;

	const navData = [
		{ name: "Home", link: "/home" },
		{ name: "Projects", link: "/project" },
		{ name: "Blog Post", link: "/blog" },
		{ name: "Achievement", link: "/achievement" },
		{ name: "About", link: "/about" },
	];

	return (
		<div class="menu sticky-top" id="my-div">
			<nav class="navbar navbar-expand-lg sticky-top my-navbar">
				<div class="container">

					<Link class="navbar-brand name" href="#" to="/home">Riyaz Hossain</Link> <button aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler bg-light" data-target="#navbarNavDropdown" data-toggle="collapse" type="button"><span class="navbar-toggler-icon"><i class="fas fa-bars"></i></span></button>

					<div class="collapse navbar-collapse" id="navbarNavDropdown">
						<ul class="navbar-nav ml-auto">
							{
								navData.map((data, index) => <li key={index} class="nav-item">
									<Link className={currentRoute === data.link ? "nav-link active-link" : "nav-link"} href={data.link} to={`${data.link}`} >{data.name}
									</Link>
								</li>)
							}
							<li class="nav-item">
								<a class="nav-link btn btn-outline-danger" href="https://drive.google.com/file/d/1uM0SE5KcqhrgQ9-5ijemS1lm4dy6XYwm/view?usp=sharing" id="resume" target="_blank">Resume</a>
							</li>
						</ul>
					</div>
				</div>
			</nav>
		</div>
	);
};
export default Header;